/* unplugin-vue-components disabled */import { render } from "./BrowserWalletImg.vue?vue&type=template&id=118727b6&scoped=true"
import script from "./BrowserWalletImg.vue?vue&type=script&lang=js"
export * from "./BrowserWalletImg.vue?vue&type=script&lang=js"

import "./BrowserWalletImg.vue?vue&type=style&index=0&id=118727b6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118727b6"]])

export default __exports__